export default __webpack_public_path__ + "static/media/pro@3x.c2b03f7d.png";